import { Cloud, Loader2 } from "lucide-react";

export default function PortalHeader({ applicationNumber, saving, savedAt }) {
  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-gray-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          {/* <div className="w-9 h-9 rounded-xl bg-[#0F2D52] flex items-center justify-center">
            <span className="font-heading font-extrabold text-white leading-none">M</span>
          </div> */}
          <img
            src="/Money_mart_symbol.webp"
            alt="Money Mart"
            className="h-[35px] w-auto object-contain"
          />
          <div className="leading-tight">
            <div className="font-heading font-extrabold text-[#0F2D52] text-sm md:text-base tracking-tight">
              Money Mart · Secure Application
            </div>
            <div className="text-[10px] uppercase tracking-[0.16em] text-gray-500 font-semibold">
              {applicationNumber ? `Ref ${applicationNumber}` : "Confidential"}
            </div>
          </div>
        </div>
        <div
          className="text-xs text-gray-500 hidden sm:flex items-center gap-2"
          data-testid="portal-save-status"
        >
          {saving ? (
            <>
              <Loader2 className="h-3 w-3 animate-spin text-[#1E5AA8]" />{" "}
              Saving…
            </>
          ) : savedAt ? (
            <>
              <Cloud className="h-3 w-3 text-[#16A34A]" /> Saved{" "}
              {savedAt.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </>
          ) : (
            <>
              <Cloud className="h-3 w-3 text-gray-400" /> Click Save & Continue to save changes
            </>
          )}
        </div>
      </div>
    </header>
  );
}
